
import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { environment } from '../../environments/environment';
import { HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class ConifgService {

SLOW_UPLOAD_THRESHOLD = 200;

user;
username;

constructor(public auth: AuthService, public http:HttpClient) {

  this.auth.userProfile$.subscribe(
    (profile) => {

      this.user = profile;
      this.username = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

 }
  private baseURL = environment.baseUrl;

  loadConfigs(): Promise<void> {
    return this.http.get<any>(this.baseURL + '/rhAPI/app/configs', { observe: 'body' }).toPromise().then(
        res => {
            console.log('Configs loaded', res);
            if(res && res.SLOW_UPLOAD_THRESHOLD){
                this.SLOW_UPLOAD_THRESHOLD = res.SLOW_UPLOAD_THRESHOLD;
            }
        }).catch(function(){
            //we'll just use defaults
        })
    }
}